// Le nom que porte un document une fois enregistré en PDF.
//
// Le CRM n'écrit pas ce fichier lui-même : c'est le navigateur, à
// « Imprimer → Enregistrer en PDF », et il propose comme nom LE TITRE DE
// L'ONGLET. Tant que ce titre restait « IMP TOITURE CRM », tous les devis et
// toutes les factures arrivaient chez le client sous le même nom, et dans le
// dossier de téléchargements sous « IMP_TOITURE_CRM (3).pdf ».
//
// D'où cette fonction : elle fabrique le titre, le navigateur en fait le nom
// de fichier. Il remplace les espaces par des tirets bas — « Devis DV2026009
// Michelle Valverde » devient « Devis_DV2026009_Michelle_Valverde.pdf ». On
// évite donc toute ponctuation de séparation, qui ressortirait en « _-_ ».
//
// Fonctions PURES : aucun accès réseau ni base, donc testables ligne à ligne.

/** Les caractères qu'un système de fichiers refuse, ou que le navigateur remplace. */
const INTERDITS = /[/\\:*?"<>|]+/g;

/** Au-delà, le nom du client est coupé : un nom de fichier doit rester lisible. */
const MAX_CLIENT = 40;

/** Un morceau de titre, nettoyé ; vide s'il n'y a rien à garder. */
function propre(v: string | null | undefined): string {
  return (v ?? '').replace(INTERDITS, ' ').replace(/\s+/g, ' ').trim();
}

/**
 * Coupe un nom trop long, sur un espace quand c'est possible : mieux vaut
 * « SARL Toitures du » que « SARL Toitures du Lub ».
 */
function raccourcir(nom: string, max: number): string {
  if (nom.length <= max) return nom;
  const coupe = nom.slice(0, max);
  const espace = coupe.lastIndexOf(' ');
  return (espace > max / 2 ? coupe.slice(0, espace) : coupe).trim();
}

/**
 * Le titre de la page d'impression, donc le nom du fichier enregistré.
 *
 * `type` est le mot qui ouvre le nom (« Devis », « Facture », « Avoir »),
 * `numero` le numéro de la pièce, `client` le nom affiché du client. Les deux
 * derniers peuvent manquer — un devis tout juste créé n'a pas encore de
 * numéro — et le nom se contente alors de ce qu'il a.
 */
export function nomDocumentImprime(
  type: string,
  numero: string | null | undefined,
  client: string | null | undefined,
): string {
  const t = propre(type);
  const n = propre(numero);
  const c = raccourcir(propre(client), MAX_CLIENT);
  const nom = [t, n, c].filter((p) => p !== '').join(' ');
  // Un document sans rien reste un document : on ne rend jamais une chaîne
  // vide, que le navigateur remplacerait par « download.pdf ».
  return nom === '' ? 'Document' : nom;
}
